import { render, staticRenderFns } from "./MyBookingDetailSideCard.vue?vue&type=template&id=e95998f0&scoped=true"
import script from "./MyBookingDetailSideCard.vue?vue&type=script&lang=ts"
export * from "./MyBookingDetailSideCard.vue?vue&type=script&lang=ts"
import style0 from "./MyBookingDetailSideCard.vue?vue&type=style&index=0&id=e95998f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95998f0",
  null
  
)

export default component.exports